<template>
  <masked-input
    ref="input"
    type="text"
    class="text-right form-control input-measure"
    :class="['is-' + state]"
    :placeholder="placeholder"
    :disabled="disabled"
    v-model="valueMask"
    @change="callChange"
    @keyup="callKeyUp"
    @keydown.enter="$emit('keydown.enter', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    :mask="numberMask"
    :guide="true"
    v-bind="$attrs"
  ></masked-input>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import MeasureMask from '_common/mixins/MeasureMask';

export default {
  name: 'InputMeasure',
  components: {
    MaskedInput,
  },
  mixins: [MeasureMask],
  props: {
    parameter: {
      type: [String, Number, Object, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Medida',
    },
    model: {
      required: true,
      default: null,
    },
    modelIndex: {
      required: true,
      default: null,
    },
    state: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      valueMask: '',
    };
  },
  watch: {
    model: {
      handler(value) {
        this.valueMask = this.addDecimalMask(value[this.modelIndex]);
      },
      deep: true,
    },
  },
  methods: {
    callChange() {
      this.model[this.modelIndex] = this.removeDecimalMask(this.valueMask);
      this.onChange(this.model, this.parameter);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    focusInput() {
      const input = this.$refs.input.$el;

      if (input) {
        input.focus();
        input.select();
      }
    },
  },
  mounted() {
    this.valueMask = this.addDecimalMask(this.model[this.modelIndex]);
  },
};
</script>

<style lang="scss">
.input-group {
  .form-control.input-measure {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}
</style>
